module.exports = __webpack_public_path__ + "static/media/71U7CvkhFuL._SL1500_.d286c2ca.jpg";